module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-06-bbd0b23e44a4a12e303f05dc39ab30af.svg";